'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SPAM = exports.SPAM = 'SPAM';
var BLOCK = exports.BLOCK = 'BLOCK';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/filtered-change-message-metadata/constants/filterTypes.js
// module id = 372
// module chunks = 2 3